export default "__VITE_ASSET__CJXPxf09__"